var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    clipPath: "url(#clip0_5089_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99898 0C7.21875 0 5.4785 0.527841 3.99829 1.51677C2.51808 2.50571 1.36439 3.91131 0.683129 5.55585C0.001863 7.20038 -0.176387 9.00998 0.170919 10.7558C0.518225 12.5016 1.37549 14.1053 2.6343 15.364C3.89312 16.6226 5.49695 17.4798 7.24297 17.8271C8.989 18.1743 10.7988 17.9961 12.4435 17.3149C14.0882 16.6337 15.494 15.4802 16.4831 14.0001C17.4721 12.5201 18 10.78 18 9C18 6.61305 17.0517 4.32387 15.3637 2.63604C13.6756 0.948212 11.3862 0 8.99898 0ZM8.63105 12.2846C8.44297 12.4679 8.1904 12.5701 7.92772 12.5691H7.91349C7.64541 12.5653 7.38969 12.4557 7.20203 12.2642L4.09802 9.06301L5.26482 7.92683L7.94195 10.687L12.7799 5.99187L13.9121 7.15854L8.63105 12.2846Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5089_202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselect);
export default __webpack_public_path__ + "static/media/multiselect.d7c577e031bd54a0fa7d8f0a365761b4.svg";
export { ForwardRef as ReactComponent };